/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function IncidentInhibateLocalCreatedReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeIncidentInhibateLocalCreatedAction }
 *     action: action de l'application
 * @return { Reducer }
 */
export const IncidentInhibateLocalCreatedReducer:
    Reducer<CombinesObjectModels<any>> =
        (state: any =
             {

             },
         action:
             actionsTypesFromStore.TypeIncidentInhibateLocalCreatedAction) => {
          switch (action.type) {
            case actions.IncidentInhibateLocalCreatedActionTypes
                .INCIDENTINHIBATELOCALCREATED_INPROGRESS:

              return {
                loading: true, ...state
              }

              break;
            case actions.IncidentInhibateLocalCreatedActionTypes
                .INCIDENTINHIBATELOCALCREATED_FAIL:

              return {
                error: action.payload.error, loading: false,
              }

              break;

            case actions.IncidentInhibateLocalCreatedActionTypes
                .INCIDENTINHIBATELOCALCREATED_SUCCESS:

              return {
                data: action.payload.data, loading: false,
              }

              break;

            default:
              return state
              break;
          }
        }


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/actions/inhibitions/created/index.ts